import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import clsx from 'clsx';

import { OnlinePill } from '@/components/Common/online-pill.tsx';

const useStyles = makeStyles((theme) => ({
    pill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.375rem',
        padding: '0.5rem 0.875rem',
        borderRadius: theme.radius.field,
        border: `1px solid ${theme.palette.common.yellow}`,
        background: theme.palette.common.white,
        color: theme.palette.common.darkGrey,
        fontFamily: 'inherit',
        fontSize: '0.875rem',
        fontWeight: theme.weight.body,
    },
    selectedPill: {
        background: theme.palette.common.lightBrown,
        boxShadow: `inset 0 0 0 1px ${theme.palette.common.yellow}`,
    },
    interactive: {
        cursor: 'pointer',
        transition: 'background 200ms ease',
        '&:hover': {
            background: theme.palette.common.lightBrown,
        },
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.common.darkGrey}`,
            outlineOffset: '1px',
        },
    },
    label: {
        fontSize: 'inherit',
        textTransform: 'none',
    },
    row: {
        // Fills its grid column instead of hugging its text, so a list of these lines up evenly.
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        justifyContent: 'space-between',
        minHeight: '3rem',
        textAlign: 'left',
    },
    rowLabel: {
        minWidth: 0,
        overflowWrap: 'anywhere',
    },
    rowMeta: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        flexShrink: 0,
    },
    chevron: {
        fontSize: '1.25rem',
        color: theme.palette.common.darkGrey,
    },
    badge: {
        flexShrink: 0,
        fontSize: '0.75rem',
        textTransform: 'none',
        color: theme.palette.common.darkGrey,
        opacity: 0.7,
    },
}));

const TreatmentPill = ({
    label,
    isOnline = false,
    badge = null,
    onClick = null,
    asRow = false,
    selected = null,
    dataTestId = undefined,
}) => {
    const classes = useStyles();

    if (!onClick) {
        return (
            <span className={classes.pill} data-testid={dataTestId}>
                <Typography component="span" className={classes.label}>
                    {label}
                </Typography>
                {isOnline && <OnlinePill />}
                {badge && (
                    <Typography component="span" className={classes.badge}>
                        {badge}
                    </Typography>
                )}
            </span>
        );
    }

    return (
        <button
            type="button"
            data-testid={dataTestId}
            aria-pressed={selected === null ? undefined : selected}
            className={clsx(classes.pill, classes.interactive, asRow && classes.row, selected && classes.selectedPill)}
            onClick={onClick}
        >
            <Typography component="span" className={clsx(classes.label, asRow && classes.rowLabel)}>
                {label}
            </Typography>
            {asRow ? (
                <span className={classes.rowMeta}>
                    {isOnline && <OnlinePill />}
                    {badge && (
                        <Typography component="span" className={classes.badge}>
                            {badge}
                        </Typography>
                    )}
                    <ChevronRightIcon className={classes.chevron} />
                </span>
            ) : (
                <>
                    {isOnline && <OnlinePill />}
                    {badge && (
                        <Typography component="span" className={classes.badge}>
                            {badge}
                        </Typography>
                    )}
                </>
            )}
        </button>
    );
};

export default TreatmentPill;
